import React from 'react';
const Slide0 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2438">
      <div className="flex flex-col space-y-6" data-id="element-2439">
        {/* Header with logo and name */}
        <div className="flex items-center space-x-4 mb-4" data-id="element-2440">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2441">
            <rect width="48" height="48" rx="8" fill="#6366F1" data-id="element-2442" />
            <path d="M14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24Z" fill="white" data-id="element-2443" />
            <path d="M22 20L28 24L22 28V20Z" fill="#6366F1" data-id="element-2444" />
          </svg>
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-2445">ShoPilots</h1>
        </div>
        {/* Tagline */}
        <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200" data-id="element-2446">
          <p className="text-xl font-semibold text-indigo-700 italic" data-id="element-2447">
            "We are moving from feature-based to need-led shopping."
          </p>
        </div>
        {/* Main text */}
        <div className="text-gray-700 mt-6" data-id="element-2448">
          <p className="text-lg" data-id="element-2449">
            ShoPilots was founded by Ben Geva and Eyal Berstein, entrepreneurs
            with deep experience in ecommerce, AI, and scaling enterprise
            software. We combine consultative sales expertise with catalog
            intelligence to deliver measurable growth.
          </p>
        </div>
        {/* Visualization */}
        <div className="mt-8 flex flex-col md:flex-row gap-6 items-center" data-id="element-2450">
          {/* Left box */}
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 flex-1" data-id="element-2451">
            <h3 className="font-semibold text-gray-800 mb-4" data-id="element-2452">
              Static catalog feed
            </h3>
            <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-2453">
              {[...Array(9)].map((_, i) => <div key={i} className="bg-gray-200 h-16 rounded-md" data-id="element-2454"></div>)}
            </div>
            <p className="text-sm text-gray-500 italic" data-id="element-2455">
              Users must figure it out.
            </p>
          </div>
          {/* Arrow */}
          <div className="transform rotate-90 md:rotate-0" data-id="element-2456">
            <svg width="48" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2457">
              <path d="M47.0607 13.0607C47.6464 12.4749 47.6464 11.5251 47.0607 10.9393L37.5147 1.3934C36.9289 0.807611 35.9792 0.807611 35.3934 1.3934C34.8076 1.97919 34.8076 2.92893 35.3934 3.51472L43.8787 12L35.3934 20.4853C34.8076 21.0711 34.8076 22.0208 35.3934 22.6066C35.9792 23.1924 36.9289 23.1924 37.5147 22.6066L47.0607 13.0607ZM0 13.5H46V10.5H0V13.5Z" fill="#6366F1" data-id="element-2458" />
            </svg>
          </div>
          {/* Right box */}
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6 flex-1" data-id="element-2459">
            <h3 className="font-semibold text-indigo-800 mb-4" data-id="element-2460">
              Conversational, need-led commerce
            </h3>
            <div className="bg-white rounded-lg p-4 mb-4 border border-gray-200" data-id="element-2461">
              <div className="flex items-start gap-2" data-id="element-2462">
                <div className="bg-indigo-100 rounded-full p-2 flex-shrink-0" data-id="element-2463">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-2464">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22Z" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2465" />
                    <path d="M8 10.5H16" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2466" />
                    <path d="M8 14H13.5" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-2467" />
                  </svg>
                </div>
                <div className="bg-indigo-50 rounded-lg p-2 text-sm text-indigo-800" data-id="element-2468">
                  I need a hoodie for €40–60
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-2469">
              <div className="flex flex-col" data-id="element-2470">
                <div className="h-24 bg-gray-200 rounded-md mb-2" data-id="element-2471"></div>
                <h4 className="font-medium text-gray-800" data-id="element-2472">Perfect Hoodie</h4>
                <p className="text-sm text-gray-600 mb-2" data-id="element-2473">€49.99</p>
                <button className="bg-indigo-600 text-white py-1 px-3 rounded-md text-sm" data-id="element-2474">
                  Add to cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide0;